import firebase from '@/firebase/firebase'
import * as moment from 'moment';
import JsZip from 'jszip';
import FileSaver from 'file-saver';

const storage = firebase.app().storage('gs://pedido-rapido-dfe');
const reference = storage.ref();

moment.locale('en'); // this is because date format of Month path

async function getFileDownloadUrl(companyId, doc) {
    // utcOffset matters! Server saves file in UTC time!
    const utcMoment = moment(doc.date).utcOffset(0).locale('en');
    const year = utcMoment.format('YYYY');
    const month = utcMoment.format('MMM');
    const filePath = `${companyId}/${year}/${month}/sent/${doc.key}.xml`;
    try {
        const docRef = reference.child(filePath);
        return await docRef.getDownloadURL();
    } catch (err) {
        console.log(`${filePath} does not exists`);
        return null;
    }
}

export default async function (companyId, documents, cb) {
    const zip = JsZip();
    await Promise.all(documents.map(async doc => { // { key, date }
        const downloadUrl = await getFileDownloadUrl(companyId, doc);
        if (downloadUrl) {
            const file = await fetch(downloadUrl);
            zip.file(`${doc.key}.xml`, file.blob());
            cb(true);
        } else
            cb(false);
    }));
    const zipFile = await zip.generateAsync({ type: 'blob', compression: 'DEFLATE', compressionOptions: { level: 4 } }); // 1 - 9
    const fileName = `notas-${moment().format('DD-MM-YYYY HH:mm:ss')}.zip`;
    return FileSaver.saveAs(zipFile, fileName);
}